export const MFA_SESSIONS_HEADER_LABELS = {
	PAGE_TITLE: 'All sessions',
	OLDER_SESSIONS_LINK: 'See older Sessions',
	TITLE_MORE_INFO:
		'Reports are available for the Mobile Flow Analyzer version 9.0.0 and newer. To see reports from previous Mobile Flow Analyzer versions, go to the Old Platform.',
	FILTERS_SECTION_ARIA_LABEL: 'Mobile Flow Analyzer filters'
} as const;
